import NoSSR from 'vue-no-ssr'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { AddressBlock, AddressForm, AddressList } from '@aspedia/address-module'

// Import startup components. These are here so they are in
// the main website bundle.
import mainwrap from '../components/website/homepage/0001/main-wrap'
import pageTop from '../components/website/page-elements/top/0001/page-top'
import mainMenu from '../components/generic/menus/main-menu'

import PageElementFooterLogo from '../components/website/page-elements/top/0001/page-element-footer-logo'
import PageHeaderSearch from '../components/website/page-elements/top/0001/page-header-search'
import BuildVersion from '../components/website/page-elements/build-verison/0001/build-version'

// Home Page elements like news and events displays
import ProgressLoader from '../components/website/page-elements/other/0001/progress-loader'
import homeFrontNews from '../components/website/homepage/news/0001/node-front-news'
import NoSSRLoader from '../components/website/page-elements/no-ssr-loader/0000/no-ssr-loader'
import ErrorPage from '../components/website/error-pages/0001/ErrorPage'
import TOSOptions from '../components/generic/tos-options'

export default function(app) {
  // Register address module components globally
  app.addStartup('address-block', AddressBlock)
  app.addStartup('address-form', AddressForm)
  app.addStartup('address-list', AddressList)

  // Add startup components.
  app.addStartup('no-ssr', NoSSR)
  app.addStartup('main-wrap', mainwrap)
  app.addStartup('page-top', pageTop)
  app.addStartup('main-menu', mainMenu)
  app.addStartup('main-menu-2', mainMenu)
  app.addStartup('page-element-footer-logo', PageElementFooterLogo)
  app.addStartup('page-header-search', PageHeaderSearch)
  app.addStartup('front-news', homeFrontNews)
  app.addStartup('progress-loader', ProgressLoader)
  app.addStartup('no-ssr-loader', NoSSRLoader)
  app.addStartup('build-version', BuildVersion)
  app.addStartup('error-page', ErrorPage)
  app.addStartup('font-awesome-icon', FontAwesomeIcon)
  app.addStartup('tos-options', TOSOptions)

  app.addComponent('user-actions', () => import(/* webpackChunkName: 'auth-user' */ '../components/generic/menus/user-actions'))
  app.addComponent('user-logout', () => import(/* webpackChunkName: 'auth-user' */ '../components/generic/generic-login/user-logout.vue'))
  app.addComponent('user-login-popup', () => import(/* webpackChunkName: 'auth-user' */ '../components/generic/generic-login/user-login-popup.vue'))
  app.addComponent('login-subform', () => import(/* webpackChunkName: 'auth-user' */ '../components/generic/generic-login/login-subform'))
  app.addComponent('page-element-user-my-account', () => import(/* webpackChunkName: 'auth-user' */ '../components/website/page-elements/top/0001/page-element-user-my-account'))
  app.addComponent('message-toast', () => import(/* webpackChunkName: 'toasts' */ '../components/generic/toasts/0001/message-toast'))
  app.addComponent('message-toast-wrapper', () => import(/* webpackChunkName: 'toasts' */ '../components/generic/toasts/0001/message-toast-wrapper'))

  /**
   * SSR Blocked Component
   *
   * This component is implemented by main-wrap.vue when
   * a route has a sub component that has a package or file
   * that attempts to utilise window / document object properties
   * which the SSR has no access to which causes it to attempt to
   * load the production index.
   *
   * To utilise this component, when you declare the the route in app.addRoutes(),
   * add a 'noSSR' key/object and this component will be rendered when the
   * SSR is active.
   *
   * @author Jayce Dugan
   * @jira 'IN-22'
   */
  app.addComponent('ssr-blocked', () => import(/* webpackChunkName: 'common-components' */ '../components/website/pages/0001/ssr-blocked.vue'))

  // Common components
  app.addComponent('AModal', () => import(/* webpackChunkName: 'common-components' */ 'dev/common-components/src/components/a-modal/AModal.vue'))
  app.addComponent('ACarousel', () => import(/* webpackChunkName: 'common-components' */ 'dev/common-components/src/components/a-carousel/0000/ACarousel.vue'))
  app.addComponent('ACarouselSlide', () => import(/* webpackChunkName: 'common-components' */ 'dev/common-components/src/components/a-carousel/0000/ACarouselSlide.js'))
  app.addComponent('ANewCarousel', () => import(/* webpackChunkName: 'common-components' */ 'dev/common-components/src/components/a-carousel/0001/ACarousel.vue'))
  app.addComponent('AImage', () => import(/* webpackChunkName: 'common-components' */ 'dev/common-components/src/components/a-image/AImage.vue'))
  app.addComponent('HighlightButton', () => import(/* webpackChunkName: 'common-components' */ 'dev/common-components/src/components/highlight-button/highlight-button.vue'))

  app.addRoutes([
    {
      path: '/error/401',
      name: 'Error401',
      component: ErrorPage,
      props: (route) => {
        return {
          code: 401,
          ...route.params
        }
      }
    },
    {
      path: '/error/403',
      name: 'Error403',
      component: ErrorPage,
      props: (route) => {
        return {
          code: 403,
          ...route.params
        }
      }
    },
    {
      path: '/error/404',
      name: 'Error404',
      component: ErrorPage,
      props: (route) => {
        return {
          code: 404,
          ...route.params
        }
      }
    },
    {
      path: '/error/500',
      name: 'Error500',
      component: ErrorPage,
      props: (route) => {
        return {
          code: 500,
          ...route.params
        }
      }
    }
  ])
}
